import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, ListGroup, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import ReactTable from "react-table";
import 'react-table/react-table.css';


export default class LeaseList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            data: [],
            dataSet: "index",
            dataRecord: "index",
            dataSetPrimaryKey: "owner_index_id" ,           
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false,
            buildingNameOptions: [],
            stillAnOccupantFilter: null,
            archiveFilter: null
        };

                      
    }
    

    async componentDidMount() {
        if (!this.props.isAuthenticated) { // if false
            return;
        }
        
        this.setState({ isLoading: false });      
    }


    componentDidUpdate(prevProps) {
       

    }

    async handleDataSave(data) {
        try {
            return await this.props.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }



    handleDeleteRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("delete agent");
        let data = [...this.props.data];
        var r = window.confirm("Are you sure you want to delete this record?");
        if (r === true) {
            console.log(cellInfo);
            data[cellInfo.index].archived = true;
            data[cellInfo.index].archived_date = new Date();
            await this.handleDataSave(data[cellInfo.index]).then((result) => {
                data.splice(cellInfo.index, 1);
                this.props.updateTableState(data, this.state.dataSet);
            }
            )
        };
    };



    handleInputChange = (cellInfo, event) => {
        
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
            
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.props.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.props.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleDropdownChange = (cellInfo, event) => {
        let data = [...this.props.data];
        console.log(event);
        data[cellInfo.index][cellInfo.column.id] = event.value;
        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.props.data];

        for (var i=0; i<data.length; i++){
            const validation = this.props.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
     
        if (data[0].hasOwnProperty("owner_name")) {
            console.log("attempting owner name search");
            data.sort(function (a, b) { 
                                        if (a.owner_name.toLowerCase() < b.owner_name.toLowerCase()) { return -1; }
                                        if (a.owner_name.toLowerCase() > b.owner_name.toLowerCase()) { return 1; }
                                        return 0;
                                        });
        }

        this.props.updateTableState(data, this.state.dataSet);

    }

    renderEditable = cellInfo => {
        const cellValue = this.props.data[cellInfo.index][cellInfo.column.id];
        

        
        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}
                        style={{
                            textAlign: "center"
                        }}
                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }


    

    addRecord = async event => {
        let data = [...this.props.data];

        //Minimum record to create (all not nulls populated)
        data.unshift({
            owner_id: this.props.ownerid,
            owner_name: "",     
            created_by: this.props.user,
            last_edited_by: this.props.user,
            new_record: true

        });
        this.props.updateTableState(data, this.state.dataSet);
    }




    renderTable(data) {
        const columns = [

            {
                id: 'owner_index_id',
                Header: 'ID',
                maxWidth: 60,
                accessor: 'owner_index_id'

            }, {
                id: 'owner_name',
                Header: 'Name',
                accessor: 'owner_name',
                Cell: this.renderEditable

            },           
            {
                Header: '',
                accessor: 'owner_index_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="danger" onClick={(e) => this.handleDeleteRecord(row, e)}>Delete</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                />
            )
        }



    }


    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>

                    i !== 0
                        ?
                        <ListGroup.Item key={i} as="a" header={d.owner_name}>
                            { d.owner_name 

                            }
                        </ListGroup.Item>

                        : ""
            );
        }
    }


    renderComponent() {
        return (
            <div className="Buildinggrades">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {this.props.controlType === "table" && <Row className="show-Container">
                    <Col className="text-right" >

                        <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>

                    </Col>
                </Row>}

                <Row className="show-Container">
                    <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType === "table" ? this.renderTable(this.props.data) : this.renderList(this.props.data)}
                    </Col>
                </Row>


            </div>
        );
    }
    render() {
        return (

            <div className="OwnerIndexList">
                {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
            </div>
        );
    }
}
